import { LidProvider } from './../../../providers/lid-provider/lid-provider';
import { ChangeDetectorRef, Component, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonInfiniteScroll, NavController, ActionSheetController, LoadingController } from '@ionic/angular';
import { ScrollHideConfig } from '../../../directives/scroll-hide';
import { CategoriesProvider, CategoryModel } from '../../../providers/categories/categories';
import { ConfigProvider } from '../../../providers/config/config';
import { LoaderProvider } from '../../../providers/loader/loader';
import { RanglistListModel, ResultListModel, ResultProvider, ResultSearchModel } from '../../../providers/result/result';
import { UserProvider } from '../../../providers/user/user';
import { SinleValueModel, ValueProvider } from '../../../providers/value/value';
import { SessionProvider } from '../../../providers/session/session';
import { EventComplex, EventProvider, EventTievts, Pager } from '../../../providers/event/event';
import { NewsRespond, NewsController } from '../../../providers/news/news-contoller';
import { TutorialProvider } from '../../../providers/tutorial/tutorial';
import { DeeplinkProvider } from '../../../providers/deeplink/deeplink';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { TrackingService } from '../../../providers/tracking.service';
import { Router } from '@angular/router';
import { NavigationService } from 'src/providers/navigation/navigation.service';
/**
 * Generated class for the ResultSearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-search',
  templateUrl: 'result-search.html',
  styleUrls:['./result-search.scss']
})
export class ResultSearchPage {
  @ViewChild('searchTop', { static: false }) searchTop: ElementRef;
  isSearchFormVisible: boolean = true;
  showMySport: boolean = false;
  headerScrollConfig: ScrollHideConfig = { cssProperty: 'top', maxValue: 100 };
  searched: boolean = false;
  savedSearchPager: Pager;
  test: boolean = false;

  currentPage = Array(3).fill(0);
  EVENTS_PER_PAGE = 10;


  @ViewChildren('resultList')
  resultList: any;

  categories: CategoryModel[];
  results: ResultListModel[] = [];
  eventsComplex: any = [];

  searchModel: ResultSearchModel = { cid: -1, limit: null, page: null, start: null, sw: '' };
  savedSearch: ResultSearchModel;

  // UI
  clientSpecific: boolean = false;
  noTitlePicture: boolean = false;
  noSearchField: boolean = false;

  // the variable is served as the switch for main background picture layout (gradient)
  // true - to show / false - to hide
  picLayout: boolean = true;

  // application id, data taken from config
  appId: string = "";

  allEventCategories = [];
  eventCatergories: any[] = [];
  eventNames: SinleValueModel[] = [];
  eventDates: SinleValueModel[] = [];
  eventDistances: SinleValueModel[] = [];
  eventTypes: SinleValueModel[] = [];


  clientSearchModel: { ena: string; dt?: string; dist?: string; t?: string; sw?: string; limit?: string; page?: string; start?: string, cid?: any} = {
    ena: '',
    dt: '',
    dist: '',
    cid: '',
    t: '',
    sw: '',
    limit: null,
    page: null,
    start: null
  };
  clientSavedSeach: { ena: string; dt?: string; dist?: string; t?: string; sw?: string; cid?: any, limit?: string; page?: string; start?: string};

  clientResults: RanglistListModel[] = [];
  postbonnClient: boolean = false;

  FIRST_LAYER: boolean = false;
  SECOND_LAYER: boolean = false;
  THIRD_LAYER: boolean = false;
  newsTab: boolean = false;

  CATEGORIES_PER_PAGE: number = 4;

  newMenu: boolean = false;
  userSection: boolean = false;

  isThurnauApp: boolean = false;
  isBrowser: boolean = false;
  isHella: boolean = false;
  newDesign: boolean = false;
  event;
  isCharity:boolean=false;

  constructor(
    public navCtrl: NavController,
    public router:Router,
    public userService: UserProvider,
    private lidService: LidProvider,
    public translate: TranslateService,
    public categoryService: CategoriesProvider,
    public resultService: ResultProvider,
    public loadingCtrl: LoadingController,
    public loadingDefCtrl:LoadingController,
    private valueService: ValueProvider,
    private config: ConfigProvider,
    private changeDetector: ChangeDetectorRef,
    private sessionService: SessionProvider,
    private eventService: EventProvider,
    private userProvider: UserProvider,
    private tutorialProvider: TutorialProvider,
    private actionSheetCtrl: ActionSheetController,
    private deeplinkService: DeeplinkProvider,
    public appDetector: AppDetectorProvider,
    public trackingService:TrackingService,
    public navService:NavigationService
  ) {
    new Promise(async (resolve, reject) => {
      const nav = this.router.getCurrentNavigation();
      const state = nav?.extras?.state || {};

      this.userSection = (await state['userSection']);
      this.showMySport = (await this.config.config).showHide.mysport;
      this.noSearchField = (await this.config.config).showHide.noSearchResults;
      this.noTitlePicture = (await this.config.config).showHide.noTitlePicResults;
      this.clientSpecific = this.searched = (await this.config.config).showHide.clientResultSearch;
      this.appId = (await this.config.config).appId;
      this.newDesign = (await this.config.config).showHide.newEventDesign;
      this.postbonnClient = (this.appId.toLowerCase().includes('postbonn')) ? true : false;
      console.log('this.appId.toLowerCase().includes(postbonn)', this.appId.toLowerCase().includes('postbonn'))
      this.isThurnauApp = (this.appId.toLowerCase().includes('thurnau')) ? true : false;
      this.isHella = (this.appId.toLowerCase().includes('hella')) ? true : false;
      this.isBrowser = (await this.config.config).platform.browser;
      this.newsTab = (await this.config.config).showHide.tabsNews;

      if (this.deeplinkService.getCurrentRequest().includes("thurnauergebnisse")) {
        this.noSearchField = true;
        this.isThurnauApp = true;
        this.newMenu = false;
        this.onSearchClient("thurnau");
      }

      let fontColor = (this.postbonnClient) ? 'black' : 'white';

      document.documentElement.style.setProperty('--text-color', fontColor);

      if (this.appId.includes('thurnau')) this.onSearchClient();
      this.allEventCategories = await this.categoryService.getEventCategoires();

      if (this.clientSpecific) {
        let lid = await this.lidService.getLid().then(r => r);
        this.resultService.getCategoriesWithResultsByLid(lid).then((values) => {
          this.eventCatergories = values || [];
          this.eventCatergories.forEach(e => e.name = this.allEventCategories.find(cat => cat.id == e.value).name);
          console.log('eventCatergories', this.eventCatergories)
          if (this.eventCatergories.length > 1) {
            if(typeof this.event!=='undefined') {
                this.clientSearchModel.cid = this.event.cid+''
            }else{
                this.clientSearchModel.cid = this.eventCatergories[0].value;
            }
          }

          this.valueService.getClientEventNames({ cid: this.clientSearchModel.cid }).then((data: SinleValueModel[]) => {
            this.newMenu = false;
            this.picLayout = (this.appId.toUpperCase().includes("FRANKFURT") ? false : true);
            this.eventNames = data || [];
            if (this.eventNames.length > 0) {
                 if(typeof this.event!=='undefined') {   
                    this.clientSearchModel.ena = this.event.name
                    this.eventNameChange();         
                // for(let i=0;i<this.eventNames.length;i++){
                //   if(this.event.name === this.eventNames[i].value){
                //     this.clientSearchModel.ena = this.eventNames[i].value
                //   }
                }else{
                    this.clientSearchModel.ena = this.eventNames[0].value;
                }
              this.eventNameChange();
            }
          });
        });
      } else {
        this.initBase();
      }
      this.onSearch();
    });
  }

  async initBase() {
    console.log('initBase: ');
    if(!this.tutorialProvider.isLoginAllowed) return;
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    this.searchModel.page = null;
    this.searchModel.limit = null;
    this.searchModel.start = null;
    this.categoryService.getResultCategoires().then((categories: CategoryModel[]) => {
      this.eventService.getEventComplex("Results", this.searchModel).then((data: EventComplex[]) => {
        this.eventsComplex = data;
        console.log('data: ', data);

        this.savedSearchPager = {
          page: this.searchModel.page,
          limit: this.searchModel.limit,
          start: this.searchModel.start
        };

        setTimeout(async () => {
          loader.dismiss();
        }, 1000);

      });

      this.newMenu = true;
      this.FIRST_LAYER = true;
      this.categories = categories;
      if (this.categories && this.categories.length > 0) {
        if(typeof this.event!=='undefined'){
          this.searchModel.cid = this.event.cid
        }else{
        this.searchModel.cid = this.categories[0].id;
        }
      }
    });
    
  }

  async eventCategoryChanged() {
    this.valueService.getClientEventNames({ cid: this.clientSearchModel.cid }).then((data: SinleValueModel[]) => {
      this.eventNames = data || [];
      if (this.eventNames.length > 0) {
         if(typeof this.event!=='undefined'){
          for(let i=0;i<this.eventNames.length;i++){
            if(this.event.name === this.eventNames[i].value){
              this.clientSearchModel.ena = this.eventNames[i].value
              this.eventNameChange();
            }
          }
        }else{
        this.clientSearchModel.ena = this.eventNames[0].value;
        this.eventNameChange();
      }
      }
    });
  }

  getEventComplex() {
    // The first one is the Virual Events category and we don't show it in result page.

    return this.eventsComplex.slice(0, this.CATEGORIES_PER_PAGE);
  }

  public clearLayers() {
    this.FIRST_LAYER = false;
    this.SECOND_LAYER = false;
    this.THIRD_LAYER = false;
  }

  onBackMenu() {
    if (this.userSection) {
      // (this.app.getRootNav() as NavController).pop();
      this.navCtrl.back();
    }
    if (this.SECOND_LAYER) {
      this.FIRST_LAYER = true;
      this.SECOND_LAYER = this.THIRD_LAYER = false;
    } else if (this.THIRD_LAYER) {
      this.SECOND_LAYER = true;
      this.FIRST_LAYER = this.THIRD_LAYER = false;
    }
  }

  onPopPage() {
    // (this.app.getRootNav() as NavController).pop();
    this.navCtrl.pop();
  }

  //(click) on event
  async onShowRangList(event) {
    console.log('event: ', event);
    if (!this.tutorialProvider.isLoginAllowed) return;
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    this.eventService.getEventId(event.eventName, event.ort, event.dateFormatted, event.cid).then(id => {
      let searchModel = { eid: '' + id, ename: '' + event.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };

      this.resultService.getRangList(searchModel).then(data => {
        this.navCtrl.navigateForward('/tab3/results/ranglist', {state:{data: { list: data, search: searchModel}}})
        .then(() => loader.dismiss());
        // loader.dismiss()
        // (this.app.getRootNav() as NavController).push(ResultRanglistPage, { data: { list: data, search: searchModel } }).then(() => loader.dismiss());
      });
    });
  }

  getResultListThurnau() {

  }

  async onEventLoad(eventDetails: EventTievts) {
  if (!this.tutorialProvider.isLoginAllowed) return;
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    console.log(eventDetails);

    this.eventService.getEventId(eventDetails.eventName, eventDetails.ort, eventDetails.dateFormatted, eventDetails.cid).then(id => {

      eventDetails.id = id;

      let searchModel = { eid: '' + id, ename: '' + eventDetails.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };

      this.navCtrl.navigateForward('/tab3/results/event-details', {state:{eventDetails: eventDetails, search: searchModel}})
      .then(() => loader.dismiss());
      // loader.dismiss()
      // (this.app.getRootNav() as NavController).push(ResultEventDetailsPage, { eventDetails: eventDetails, search: searchModel })
        // .then(() => loader.dismiss());
    });
  }

  loadNextSportsPage(event: any, i: number) {
    const infiniteScroll = event.target as IonInfiniteScroll;
    this.eventService.getEventComplex("Results", this.savedSearchPager).then((data: EventComplex[]) => {
      this.eventsComplex[i].event = this.eventsComplex[i].event.concat(data[i].event);
      infiniteScroll.complete();
    });
  }

  arrayOf(events: EventTievts[], i: number): EventTievts[] {
    if (events.length == 0)
      return null;

    if (this.isLastPage(events.length, i)) {
      return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] * this.EVENTS_PER_PAGE) + (events.length % this.EVENTS_PER_PAGE));
    }
    return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] + 1) * this.EVENTS_PER_PAGE);
  }

  getAllEvents(i: number) {
    return this.eventsComplex[i].event.slice(0, 10);
  }

  isFirstPage(i: number): boolean {
    return (this.currentPage[i] == 0) ? true : false;
  }

  isLastPage(n: number, i: number): boolean {
    return ((this.currentPage[i] + 1) > (n / this.EVENTS_PER_PAGE)) ? true : false;
  }

  nextPage(i: number) {
    this.currentPage[i]++;
  }

  prevPage(i: number) {
    this.currentPage[i]--;
  }

  eventNameChange(event?:any) {
    if(event){
      this.clientSearchModel.ena = event.detail.ena;
    }
    let client = (this.userSection) ? 'p' : 'g';
    this.valueService.getClientEventDates({ ena: this.clientSearchModel.ena, cid: this.clientSearchModel.cid }, client).then(dates => {
      console.log('dates: ', dates);
      this.eventDates = dates;
      console.log('this.eventDates: ' + this.eventDates);
      this.changeDetector.detectChanges();
      if (dates.length > 0) {
        let date = this.getLatestDate(dates);
        this.clientSearchModel.dt = dates[0].value;
        this.eventDateChange();
      }
    });
  }

  getLatestDate(dates) {
    console.log('dates: ', dates);
    return null;
  }

  eventDateChange(event?:any) {
    if(event){
      this.clientSearchModel.dt = event.detail.value;
    }
    if (this.clientSearchModel.dt !== '') {
      let client = (this.userSection) ? 'p' : 'g';
      this.valueService.getClientEventDistances({ ena: this.clientSearchModel.ena, dt: this.clientSearchModel.dt, cid: this.clientSearchModel.cid }, client).then(distances => {
        this.eventDistances = distances || [];
        this.changeDetector.detectChanges();
        if (this.eventDistances.length > 0) {
          this.resultService.isDonate = distances.findIndex(x => x.value.toLocaleLowerCase().includes('spen') || x.value.toLocaleLowerCase().includes('char')) > -1 ? true : false;
          if(this.resultService.isDonate==true){
            this.isCharity=true;
          }
          console.log('this.resultService.isDonate: ', this.resultService.isDonate);
            if(typeof this.event!=='undefined') {
                this.clientSearchModel.dist = this.event.streckeconv
                for(let i=0;i<distances.length;i++){
                if(this.event.streckeconv === distances[i].value){
                    this.clientSearchModel.dist = distances[i].value
                    this.eventDistanceChange();
              }
            }
          }else{
          this.clientSearchModel.dist = this.eventDistances[0].value;
          // this.onSearchClient();
          this.eventDistanceChange();
          }
        }
      });
    } else {
      this.clientSearchModel.dist = '';
      this.clientSearchModel.t = '';
      this.clientSearchModel.cid = '';
    }
  }

  async ionViewWillEnter() {
    console.log("RESULTS PAGE WILL ENTER");
    console.log(this.appId.includes("event"));
    console.log(this.deeplinkService.getCurrentRequest().includes("done"));
    console.log(this.newMenu);
    if (this.deeplinkService.getCurrentRequest().includes("done") && this.appId.includes("event") && !this.newMenu) {
      this.initBase();
    }
    if (!this.userSection)
      this.checkNews();
  }

  ionViewWillLeave() {
    console.log('RESULTS PAGE LEFT')
    if (this.deeplinkService.getCurrentRequest().includes("thurnauergebnisse")) {
      this.deeplinkService.currentRequest = "done";
      this.isThurnauApp = false;
      this.newMenu = false;
      this.searched = false;
      this.noSearchField = false;
      this.clientResults = [];
    }
  }

  async checkNews() {
    if (this.appDetector.isForestApp()) return;

    let loader = await this.loadingCtrl.create();
    loader.present();

    if (!this.newsTab) { 
      loader.dismiss(); 
      return; }

    NewsController.getInstance().getNews().then((respond) => {
      console.log('respond: ');
      console.log(JSON.stringify(respond));
      if (respond.update) {
        if (respond.type.toLocaleUpperCase().includes("DHL")) {
          this.userProvider.checkLoged().then(logged => {
            console.log('logged: ', logged);
            if (logged) {
              if (this.sessionService.profile.clubName.includes("DHL"))
                this.presentNewsActionSheet(respond);
            }
            else
              return;
          });
        } else {
          this.presentNewsActionSheet(respond);
        }
      }

      loader.dismiss();
    });
  }

  getAllResults(i: number) {
    return this.eventsComplex[i].event;
  }

  ngOnInit() {
    console.log('RESULTS PAGE DID LOAD');
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    this.event = state['event'];
    console.log('result-search event', this.event)
    if(typeof this.event!=='undefined'){
      this.FIRST_LAYER = true
    }
    // let view = this.navCtrl.getActive();

    // console.log(view.component.name);
     console.log('Current route:', this.router.url);
  }

  async presentNewsActionSheet(respond: NewsRespond) {
    if (respond.type.includes("DHL") && !this.appId.includes("postbonn")) {
      return;
    }

    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('NEW_NEWS'),
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            if (respond.type.includes("DHL")) {
              if (this.sessionService.profile.clubName.includes("Deutsche Post DHL Group") && this.appId.includes("postbonn")) {
                this.navCtrl.navigateForward('/notification', {state:{news: respond.data, dhl: true }});
                // (this.app.getRootNav() as NavController).push(NotificationPage, { news: respond.data, dhl: true });
              }
            }
            else {
              // this.app.getRootNav().getActiveChildNav().select(1);
              this.navCtrl.navigateForward('/tab1');
            }
          }
        },
        {
          text: this.translate.instant('GLOBAL_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();
  }

  eventDistanceChange(event?:any) {
    if(event){
      this.clientSearchModel.dist = event.detail.value;
    }
    if (this.clientSearchModel.dist !== '') {
      let client = (this.userSection) ? 'p' : 'g';
      this.valueService
        .getClientEventTypes({ ena: this.clientSearchModel.ena, dt: this.clientSearchModel.dt, dist: this.clientSearchModel.dist, cid: this.clientSearchModel.cid }, client)
        .then(async(types) => {
          this.eventTypes = types;
          this.changeDetector.detectChanges();
          if (types.length >= 1) {
            if(typeof this.event!=='undefined'){
              if(this.clientSearchModel.ena ==='Paris Digital Run' || this.clientSearchModel.ena ==='Great Wall Challenge'
              || this.clientSearchModel.ena ==='Hollywood Digital Run' || this.clientSearchModel.ena ==='Antarctics Challenge'){
                this.event.wertung = "Gesamtwertung"
              }
              else if(this.clientSearchModel.ena==='New York Digital Run'){
                this.clientSearchModel.t = "Frauen  (Alle Jahrgänge)"
                // this.onSearchClient();
              }
              this.clientSearchModel.t = this.event.wertung
              console.log(this.clientSearchModel.t)
            }
            else{
            this.clientSearchModel.t = types[0].value;
            }
            await this.onSearchClient();
          }
        });
    } else {
      this.clientSearchModel.t = '';
      this.clientSearchModel.cid = '';
    }
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  public scrollIntoView(view?:any) {
    if (view) {
      view.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    if (this.searchTop?.nativeElement) {
      this.searchTop.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  expandForm() {
    this.isSearchFormVisible = !this.isSearchFormVisible;
  }

  async onSearch() {
    console.log('onSearch')
    if (!this.tutorialProvider.isLoginAllowed) return;
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.searched = true;
    if (this.searchModel.page) {
      this.searchModel.page = 0 + '';
    }
    this.resultService.searchResults(this.searchModel).then((results: ResultListModel[]) => {
      this.results = results;
      this.savedSearch = {
        cid: this.searchModel.cid,
        limit: this.searchModel.limit,
        page: this.searchModel.page,
        start: this.searchModel.start,
        sw: this.searchModel.sw
      };
      this.changeDetector.detectChanges();
      loader.dismiss().then(() => {
        if (this.results.length > 0){
          // this.scrollIntoView(this.resultList.first.nativeElement);
          const firstItem = this.resultList.first.el.querySelector('ion-item');
          firstItem?.scrollIntoView({ behavior: 'smooth', block: 'start' });
           
        }
      });
    });
  }

  getName(index: number) {
    if (this.results.length < 1) return "";
    return this.results[index].athleteName;
  }

  
  async onSearchClient(appName?) {
    console.log('onSearchClient: ');

    if (!this.tutorialProvider.isLoginAllowed) return;

    const loader = await this.loadingDefCtrl.create({
      message: this.translate.instant('GLOBAL_LOADING'),
      spinner: 'crescent'
    });
    // await loader.present();

    this.searched = true;
    this.newMenu = false;

    if (this.clientSearchModel.page) {
      this.clientSearchModel.page = '0';
    }

    const specialRequest = !!this.userSection;

    this.resultService.clientSearchResults(this.clientSearchModel, specialRequest, appName || this.appId)
      .then((data) => {
        if (data.length === 0) {
          this.resultList.isDonate = true;
        }

        this.clientSavedSeach = { ...this.clientSearchModel };

        this.clientSearchModel.limit = null;
        this.clientSearchModel.page = null;
        this.clientSearchModel.start = null;

        this.clientResults = data;
        console.log('this.clientSearchModel', this.clientSearchModel);
        console.log('clientResults', this.clientResults);

        this.changeDetector.detectChanges();

        if (this.clientResults.length > 0) {
          const firstItem = this.resultList.first.el.querySelector('ion-item');
          // this.scrollIntoView(firstItem);
          firstItem?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        loader.dismiss(); 
      });
  }



  loadNextPage(event: any) {
    const infiniteScroll = event.target as IonInfiniteScroll;
    if (this.clientSpecific) {
      this.loadNextPageClient(infiniteScroll);
    } else {
      this.loadNextPageBase(infiniteScroll);
    }
  }

  loadNextPageBase(event: IonInfiniteScroll) {
    this.resultService.searchResults(this.savedSearch).then((data: ResultListModel[]) => {
      this.results = this.results.concat(data);
      event.complete();
    });
  }

  loadNextPageClient(event: IonInfiniteScroll) {
    let specialRequest = (this.userSection) ? true : false;

    this.resultService.clientSearchResults(this.clientSavedSeach, specialRequest, this.appId).then(data => {
      data = data.filter(x => !this.clientResults.find(y => x.id === y.id));
      this.clientResults = this.clientResults.concat(data);
      event.complete();
    });
  }

  async showLogin() {
    if (this.isHella && !this.sessionService.isLoged) {
      // (this.app.getRootNav() as NavController).push(IdRegistrationPage);
      this.navCtrl.navigateForward('/auth/id-registration');
    } else {
    if (!this.tutorialProvider.isLoginAllowed) return;
      const loader = await this.loadingDefCtrl.create({
        message: this.translate.instant('GLOBAL_LOADING'),
        spinner: 'crescent'
      });
      let profile = this.sessionService.isLoged ? this.sessionService.profile : null;

      this.valueService.getProfileBackgrounds().then(backgrounds => {
        this.navCtrl.navigateForward('/tab2/me/mysport/user-profile', {state:{data: { profile: profile, backgrounds: backgrounds }}})
        .then(()=>{
          loader.dismiss()})
      }).catch(()=>loader.dismiss()).finally(()=>loader.dismiss());
    }
  }

  eventTypePass: string;

  getEventType() {
    return this.eventTypePass;
  }

  onMorePress(event: EventComplex) {
    this.eventTypePass = event.category;
    this.FIRST_LAYER = false;
    this.SECOND_LAYER = true;
  }

  eventArea: string;

  getEventArea() {
    console.log(this.eventArea);
    return this.eventArea;
  }

  onLoadThirdLayer(area) {
    this.eventArea = area;
    this.SECOND_LAYER = false;
    this.THIRD_LAYER = true;
  }
  onSearchModelCidChange(event:any){
    this.searchModel.cid = event.detail.value;
  }
  onSearchModelSwChange(event:any){
    this.searchModel.sw = event.detail.value;
  }
  onClientSearchModelSwChange(event:any){
    this.clientSearchModel.sw = event.detail.value;
  }
}

